//#region src/engine/modules/dictionary/actions.ts
var ActionType = {
	addDictionary: "dictionary.add",
	updateDictionary: "dictionary.update",
	removeDictionary: "dictionary.remove"
};
var DictionaryKind = {
	word: "word",
	term: "term",
	domain: "domain"
};
var DictionaryKindList = Object.values(DictionaryKind);
var DictionaryFields = {
	[DictionaryKind.word]: [
		"name",
		"abbreviation",
		"englishName",
		"description",
		"synonyms",
		"forbiddenWords"
	],
	[DictionaryKind.term]: [
		"name",
		"physicalName",
		"domainId",
		"description",
		"synonyms"
	],
	[DictionaryKind.domain]: [
		"name",
		"category",
		"dataType",
		"description"
	]
};
var DictionaryStoredFields = {
	[DictionaryKind.word]: [...DictionaryFields.word, "order"],
	[DictionaryKind.term]: [...DictionaryFields.term, "order"],
	[DictionaryKind.domain]: [...DictionaryFields.domain, "order"]
};
//#endregion
export { ActionType, DictionaryFields, DictionaryKind, DictionaryKindList, DictionaryStoredFields };
